import { getElemDistance } from "Jarvis/JarvisServices/JarvisHtmlService";
import React, { useEffect, useRef, useState } from "react";

const MainContainerBody = React.forwardRef(({ children }, ref) => {
  const [height, setHeight] = useState();
  const internalRef = useRef();
  const targetRef = ref ?? internalRef;
  useEffect(() => {
    const elem = targetRef.current;
    const elemTop = getElemDistance(elem);
    const footer = document.querySelector(".app-footer");
    const footerTop = getElemDistance(footer);
    const h = footerTop - elemTop - 20;
    setHeight(h);
  }, [targetRef]);
  return (
    <div
      ref={targetRef}
      className="jr-card"
      style={{
        padding: "15px",
        height: height,
        overflow: "auto",
      }}
    >
      <div className="js-card-body" style={{ minHeight: "100%" }}>
        {children}
      </div>
    </div>
  );
});
export default MainContainerBody;
